<template>
  <div>
    <table-view
      :isBusy="isLoading"
      :fields="fields"
      :items="list"
      title="Reason Master"
    >
      <template v-slot:add>
        <create-reason @init="init" v-if="isCreate"></create-reason>
      </template>
      <template v-slot:is_active="{ value }">
        {{ value == 1 ? "Active" : "Inactive" }}
      </template>
      <template v-slot:action="{ item }">
        <div class="d-flex" v-if="isAction(item)">
          <create-reason :item="item" @init="init"></create-reason>
          <delete-button @click="remove(item)"></delete-button>
        </div>
      </template>
    </table-view>
  </div>
</template>

<script>
import masterService from "../../assets/services/master.service";
import DeleteButton from "../buttons/DeleteButton.vue";
import TableView from "../table/TableView.vue";
import CreateReason from "./create/CreateReason.vue";
export default {
  components: { TableView, DeleteButton, CreateReason },
  data() {
    return {
      list: [],
      isLoading: false,
    };
  },
  computed: {
    fields() {
      let doc = {
        reason_text: "Reason",
        reason_type: "Type",
        is_active: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          sortable: true,
          label: doc[key],
          tdClass: key == "action" ? "width-100" : "",
        });
      });
      return list;
    },
    isCreate() {
      return true;
    },
  },
  methods: {
    isAction({ is_active }) {
      return is_active == 1;
    },
    async remove({ reason_id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to remove this?",
        onConfirm: async () => {
          try {
            let { data } = await masterService.getReasonMaster({
              reason_id,
              dml_indicator: "D",
            });
            let { status, msg } = data;
            vm.init();
            if (!status) {
              vm.$alert.show(msg);
            }
          } catch (error) {
            vm.isLoading = false;
            vm.$alert.show(error.message);
          }
        },
      });
    },
    async init() {
      const vm = this;
      try {
        vm.list = [];
        vm.isLoading = true;
        let { data } = await masterService.getReasonMaster({
          dml_indicator: "S",
        });
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (status) {
          vm.list = list || [];
        } else {
          vm.$alert.show(msg);
        }
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
